import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { trackAppStoreCtaClick } from '../utils/analytics';

function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobileMenuOpen && !event.target.closest('.mobile-nav') && !event.target.closest('.hamburger-button')) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobileMenuOpen]);

  return (
    <header className="app-header">
      <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
        <h1>Acne Safe</h1>
      </Link>
      
      {/* Desktop Navigation */}
      <div className="header-buttons desktop-nav">
        <Link to="/pore-clogging-ingredient-checker" className="chrome-extension-button">
          Pore Clogging Checker
        </Link>
        <Link to="/products" className="chrome-extension-button">
          Products
        </Link>
        <Link to="/ingredients" className="chrome-extension-button">
          Ingredients
        </Link>
        <Link to="/blog" className="chrome-extension-button">
          Blog
        </Link>
        <a href="https://chromewebstore.google.com/detail/acnesafe/jfphllcnckidjfjploadnmbkljnjlmhh" target="_blank" rel="noopener noreferrer" className="chrome-extension-button">
          Try our chrome extension
        </a>
        <a href="https://apps.apple.com/us/app/acne-safe-ingredient-scanner/id6747936538" target="_blank" rel="noopener noreferrer" className="app-store-button" onClick={() => trackAppStoreCtaClick('header_desktop')}>
          <img src="/download.png" alt="Download on App Store" className="download-button-image" />
        </a>
      </div>

      {/* Mobile Hamburger Button */}
      <button 
        className="hamburger-button"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        aria-label="Toggle mobile menu"
      >
        <span className={`hamburger-line ${isMobileMenuOpen ? 'active' : ''}`}></span>
        <span className={`hamburger-line ${isMobileMenuOpen ? 'active' : ''}`}></span>
        <span className={`hamburger-line ${isMobileMenuOpen ? 'active' : ''}`}></span>
      </button>

      {/* Mobile Navigation Menu */}
      <div className={`mobile-nav ${isMobileMenuOpen ? 'open' : ''}`}>
        <Link to="/pore-clogging-ingredient-checker" className="mobile-nav-link" onClick={() => setIsMobileMenuOpen(false)}>
          Pore Clogging Checker
        </Link>
        <Link to="/products" className="mobile-nav-link" onClick={() => setIsMobileMenuOpen(false)}>
          Products
        </Link>
        <Link to="/ingredients" className="mobile-nav-link" onClick={() => setIsMobileMenuOpen(false)}>
          Ingredients
        </Link>
        <Link to="/blog" className="mobile-nav-link" onClick={() => setIsMobileMenuOpen(false)}>
          Blog
        </Link>
        <a href="https://chromewebstore.google.com/detail/acnesafe/jfphllcnckidjfjploadnmbkljnjlmhh" target="_blank" rel="noopener noreferrer" className="mobile-nav-link" onClick={() => setIsMobileMenuOpen(false)}>
          Try our chrome extension
        </a>
        <a
          href="https://apps.apple.com/us/app/acne-safe-ingredient-scanner/id6747936538"
          target="_blank"
          rel="noopener noreferrer"
          className="mobile-nav-link"
          onClick={() => {
            trackAppStoreCtaClick('header_mobile');
            setIsMobileMenuOpen(false);
          }}
        >
          <img src="/download.png" alt="Download on App Store" className="download-button-image" />
        </a>
      </div>
    </header>
  );
}

export default Header;
